window.addEventListener('load', function() {
    setTimeout(function() {
        var element = document.querySelector('.sls-purchase-options-container');
        if (element) {
            // Set inline style with !important to override external CSS
            element.style.setProperty('display', 'block', 'important');
        } 
    }, 1000); // 500ms buffer is usually sufficient to catch late-loading scripts
});